// extracted by mini-css-extract-plugin
module.exports = {"section":"Info_section__2CDxn","title":"Info_title__3qNfg","body":"Info_body__27cI2","link":"Info_link__2bByv","li-icon":"Info_li-icon__2yBoC"};